import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Order = ApplicationRecord.extend({
  static: {
    jsonapiType: 'orders',
  },
  attrs: {
    id: attr(),
    email: attr(),
    address: attr(),
    address2: attr(),
    firstName: attr(),
    lastName: attr(),
    notes: attr(),
    shippingAddress: attr(),
    shippingAddress2: attr(),
    react: attr(),
    schoolPrice: attr(),
    shippingCity: attr(),
    shippingState: attr(),
    shippingZip: attr(),
    hasDownloadableImages: attr(),
    hasSeniorBuyAll: attr(),
    needsFullResImages: attr(),
    createdAt: attr(),
    cart: belongsTo(),
  },
  methods: {
    shippingLineTwo: function() {
      return `${this.shippingCity ? this.shippingCity : ''}, ${this.shippingState ? this.shippingState : ''} ${this.shippingZip ? this.shippingZip : ''}`
    },
    fullName: function(surnameFirst = false) {
      if (surnameFirst) return `${this.lastName}, ${this.firstName}`;

      return `${this.firstName} ${this.lastName}`
    }
  }
});

export default Order;
